module.exports = __webpack_public_path__ + "img/Ute_Back_Side_Left.c1c3525c.svg";